import pino from 'pino';
import type { Config } from './config.js';

/** Redacts anything that could carry secrets so logs never contain passwords or tokens. */
export function createLogger(config: Pick<Config, 'NODE_ENV' | 'LOG_LEVEL'>) {
  return pino({
    level: config.NODE_ENV === 'test' ? 'silent' : config.LOG_LEVEL,
    redact: {
      paths: [
        'req.headers.authorization',
        'req.headers.cookie',
        'res.headers["set-cookie"]',
        '*.password',
        '*.token',
        '*.refreshToken',
        '*.accountNumber',
      ],
      censor: '[redacted]',
    },
    transport:
      config.NODE_ENV === 'development'
        ? { target: 'pino-pretty', options: { colorize: true, translateTime: 'HH:MM:ss' } }
        : undefined,
  });
}

export type Logger = ReturnType<typeof createLogger>;
